import React from 'react';
import { StyledBackButton, StyledBackButtonText } from './BackButton.styles';
import { useRouter } from 'next/router';
import { SIZE } from 'app/ui-components/typography/PlayText/PlayText';
import { trackCustomEvent } from 'app/utils/statistics/clientStatistics';
import { trackModalBack } from 'app/utils/statistics/customEvents';

export const BackButton = () => {
    const router = useRouter();

    const handleBack = () => {
        trackCustomEvent(trackModalBack());
        // `state.idx` seems to be the length of the local history stack.
        // It's however undocumented so this may break in the future ¯\_(ツ)_/¯
        if (window.history.state && window.history.state.idx > 0) {
            router.back();
        } else {
            const { slug } = router.query;
            router.push({ pathname: router.pathname, query: { slug } });
        }
    };

    return (
        <StyledBackButton
            role="button"
            data-rt="modal-back-button"
            aria-label="Stäng videospelaren"
            onClick={handleBack}
        >
            <StyledBackButtonText size={SIZE.MINI}>Tillbaka</StyledBackButtonText>
        </StyledBackButton>
    );
};

export default BackButton;
